var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPreview20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.856 9.304C15.717 6.689 13.026 5 10 5S4.283 6.69 3.144 9.304a1.75 1.75 0 000 1.392C4.283 13.31 6.974 15 10 15c3.027 0 5.717-1.69 6.856-4.304a1.75 1.75 0 000-1.392zM10 12.222c-1.287 0-2.333-.996-2.333-2.222 0-1.225 1.046-2.222 2.333-2.222 1.287 0 2.334.997 2.334 2.222 0 1.226-1.047 2.222-2.334 2.222z",
    fill: "#868E96"
  })));
}

export default SvgPreview20;